<template>
  <div
    class="
      modal-success-wrapper
      d-flex
      align-items-center
      justify-content-center
    "
  >
    <div>
      <div class="d-flex justify-content-center pb-4">
        <font-awesome-icon
          class="success-icon"
          :icon="['fas', 'check-circle']"
          size="lg"
        />
      </div>
      <div class="description d-flex justify-content-center">
        {{ description }}
      </div>
      <div v-if="subDescription" class="d-flex justify-content-center small-copy mt-2">
        {{ subDescription }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "modal-success",
  props: ["description", "subDescription"],
};
</script>

<style scoped>
.modal-success-wrapper {
  min-height: 250px;
  font-size: 18px;
}
.success-icon {
  color: #2bc275;
  font-size: 100px;
}
.description {
  font-family: artifaktElementBold;
}
</style>



// WEBPACK FOOTER //
// src/components/homebase/modals/ModalSuccess.vue